import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3119819440/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Additional Requirements for .Lawyer, .Dentist, and .Attorney Domains</h1>
The registry provider has designated .lawyer, .dentist, and .attorney as a Highly-Regulated
TLDs. Highly Regulated TLDs require the following conditions be maintained for all
domain registrations:
    <ul>
  <li>
    1. Registrant's must provide administrative contact information, which must
    be kept up-to-date, for the notification of complaints or reports of
    registration abuse, as well as the contact details of the relevant
    regulatory, or industry self-regulatory, bodies in their main place of
    business;
  </li>
  <li>
    2. Registrant assert they possess any necessary authorizations, charters,
    licenses and/or other related credentials for participation in the sector
    associated with such Highly-regulated TLD;
  </li>
  <li>
    3. Registrant must report any material changes to the validity of the
    Registrant’s authorizations, charters, licenses and/or other related
    credentials for participation in the sector associated with the
    Highly-regulated TLD to ensure the Registrant continues to conform to the
    appropriate regulations and licensing require ments and generally conduct
    their activities in the interests of the consumers they serve.
  </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      